"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = require("./state");
exports.useStorageState = state_1.default;
var reducer_1 = require("./reducer");
exports.useStorageReducer = reducer_1.default;
//# sourceMappingURL=index.js.map